import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import {
  APIOrchidDriveDirectory,
  APIOrchidDriveFile,
  OrchidDriveUploadTask,
  orchidDriveUploadTaskFromAPI,
} from "../types";

export async function createUploadTask(
  totalExpectedSize: null | number,
  orchidUniqueDeviceId: string | null,
  abortController?: AbortController,
): Promise<OrchidDriveUploadTask> {
  const response = await fetchOrchidAPI(`/api/drive_data/upload_task/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      total_expected_size: totalExpectedSize,
      orchid_unique_device_id: orchidUniqueDeviceId,
    }),
    signal: abortController?.signal,
  });
  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  const responseData = await response.json();
  return orchidDriveUploadTaskFromAPI(responseData);
}

export async function finalizeUploadTask(
  uploadTaskId: string,
  abortController?: AbortController,
): Promise<{
  fileEntries: APIOrchidDriveFile[];
  directoryEntries: APIOrchidDriveDirectory[];
  uploadTaskEntry: OrchidDriveUploadTask;
}> {
  const response = await fetchOrchidAPI(
    `/api/drive_data/upload_task/finalize_upload/${uploadTaskId}`,
    {
      method: "POST",
      signal: abortController?.signal,
    },
  );
  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  const responseData = await response.json();

  return {
    fileEntries: responseData.file_entry_changes,
    directoryEntries: responseData.directory_entry_changes,
    uploadTaskEntry: orchidDriveUploadTaskFromAPI(responseData.upload_task),
  };
}

export async function abandonUploadTask(
  uploadTaskId: string,
  abortController?: AbortController,
): Promise<{
  fileEntries: APIOrchidDriveFile[];
  directoryEntries: APIOrchidDriveDirectory[];
  uploadTaskEntry: OrchidDriveUploadTask;
}> {
  const response = await fetchOrchidAPI(
    `/api/drive_data/upload_task/abandon_upload/${uploadTaskId}`,
    {
      method: "DELETE",
      signal: abortController?.signal,
    },
  );
  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  const responseData = await response.json();

  return {
    fileEntries: responseData.file_entry_changes,
    directoryEntries: responseData.directory_entry_changes,
    uploadTaskEntry: orchidDriveUploadTaskFromAPI(responseData.upload_task),
  };
}
